/*
 *
 * EkycPage actions
 *
 */

import {
  CHANGE_AADHAAR_NUMBER,
  CHANGE_OTP_CODE,
  ADD_FORM_FIELD_ERROR,
  TOGGLE_CONSENT,
  FETCH_PUBLIC_KEY_REQUEST,

  FETCH_PUBLIC_KEY_SUCCESS,
  FETCH_PUBLIC_KEY_FAILURE,
  GENERATE_OTP_REQUEST,
  GENERATE_OTP_SUCCESS,
  GENERATE_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  EKYC_STATUS_REQUEST,
  EKYC_STATUS_SUCCESS,
  EKYC_STATUS_FAILURE,
  EDIT_AADHAAR_NUMBER,
  REDIRECT_REQUEST,
  RESET_EKYC_FORM,
  UPDATE_KYC_ID,
  HANDLE_VID_MODAL,
} from './constants';

export function changeAadhaarNo(value) {
  return {
    type: CHANGE_AADHAAR_NUMBER,
    value,
  };
}

export function changeOtpCode(value) {
  return {
    type: CHANGE_OTP_CODE,
    value,
  };
}

export function addFormError(errorKey, errorValue) {
  return {
    type: ADD_FORM_FIELD_ERROR,
    errorKey,
    errorValue,
  };
}

export function toggleConsent() {
  return {
    type: TOGGLE_CONSENT,
  };
}

// Public Key
export function fetchPublicKeyRequest() {
  return {
    type: FETCH_PUBLIC_KEY_REQUEST,
  };
}

export function fetchPublicKeySuccess(response) {
  return {
    type: FETCH_PUBLIC_KEY_SUCCESS,
    response,
  };
}

export function fetchPublicKeyFailure(error) {
  return {
    type: FETCH_PUBLIC_KEY_FAILURE,
    error,
  };
}

// Generate OTP
export function generateOtpRequest() {
  return {
    type: GENERATE_OTP_REQUEST,
  };
}

export function generateOtpSuccess(response) {
  return {
    type: GENERATE_OTP_SUCCESS,
    response,
  };
}

export function generateOtpFailure(error) {
  return {
    type: GENERATE_OTP_FAILURE,
    error,
  };
}

// Verify OTP
export function verifyOtpRequest() {
  return {
    type: VERIFY_OTP_REQUEST,
  };
}

export function verifyOtpSuccess(response) {
  return {
    type: VERIFY_OTP_SUCCESS,
    response,
  };
}

export function verifyOtpFailure(error) {
  return {
    type: VERIFY_OTP_FAILURE,
    error,
  };
}

// eKYC Status
export function ekycStatusRequest() {
  return {
    type: EKYC_STATUS_REQUEST,
  };
}

export function ekycStatusSuccess(response) {
  return {
    type: EKYC_STATUS_SUCCESS,
    response,
  };
}

export function ekycStatusFailure(error) {
  return {
    type: EKYC_STATUS_FAILURE,
    error,
  };
}

// Edit / Reset
export function editAadhaarNo() {
  return {
    type: EDIT_AADHAAR_NUMBER,
  };
}

export function redirectKyc(errorCode) {
  return {
    type: REDIRECT_REQUEST,
    errorCode,
  };
}

export function resetEkycForm() {
  return {
    type: RESET_EKYC_FORM,
  };
}

// KYC ID
export function updateKycId(kycId) {
  return {
    type: UPDATE_KYC_ID,
    kycId,
  };
}

// VID Modal
export function handleVidModal(open) {
  return {
    type: HANDLE_VID_MODAL,
    open,
  };
}
